import axios from './axios';

export default {
  list() {
    return axios.get('/courses');
  },
  get(id) {
    return axios.get(`/courses/${id}`);
  },
  subscribe(id) {
    return axios.post(`/courses/${id}/subscriptions.json`);
  },
};
